import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Image from '@plone/volto/components/theme/Image/Image';
import config from '@plone/volto/registry';
import cx from 'classnames';
import ImageCaption from 'govbr.frontend.policy/components/ImageCaption/ImageCaption';
import PropTypes from 'prop-types';

const View = ({ data, properties }) => {
  // Personaliza para nao gerar erro de tag vazia
  if (!properties.image) {
    return null;
  }

  return (
    <figure
      className={cx(
        'block image align',
        {
          center: !Boolean(data.align),
        },
        data.align,
      )}
    >
      <>
        {(() => {
          const image = (
            //Customização: texto alt
            <Image
              className={cx({ 'full-width': data.align === 'full' })}
              item={properties}
              imageField="image"
              sizes={config.blocks.blocksConfig.leadimage.getSizes(data)}
              alt={properties.alt || ''}
              responsive={true}
            />
            //fim da customização
          );
          if (data.href) {
            return (
              <UniversalLink
                href={data.href}
                openLinkInNewTab={data.openLinkInNewTab}
              >
                {image}
              </UniversalLink>
            );
          } else {
            return image;
          }
        })()}
        <ImageCaption caption={properties.image_caption} />
      </>
    </figure>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
